export const DropdownArrowSvg: string =
`<svg xmlns="http://www.w3.org/2000/svg" class="$state$" width="18" height="18">
  <style>
    .onDarkBackground{opacity:0.5}
    .onDarkBackground.active,.onDarkBackground.hover{opacity:1}
    .disabled{opacity:0.35!important}
    .active path,.hover path{fill:#333}
    path,.disabled path{fill:#666}
    .onDarkBackground path{fill:#fff!important}
  </style>
  <path d="M5.8 7.3l3.5 4.6c.1.1.2.1.3 0l3.6-4.6c.1-.2 0-.3-.2-.3H6c-.2 0-.3.1-.2.3z"/>
</svg>`;
